// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_AI_SUMMARY_BADGE = "Zhrnutie diskusie";
export const FORUM_AI_SUMMARY_COMMENTS_count = "%(count)s pr\u00edspevkov";
export const FORUM_AI_SUMMARY_DISCLAIMER = "Automatick\u00fd s\u00fahrn diskusie generovan\u00fd umelou inteligenciou";
export const FORUM_AI_SUMMARY_HIDE = "Skry\u0165";
export const FORUM_AI_SUMMARY_SHOW = "Zobrazi\u0165 cel\u00e9 zhrnutie a \u010dast\u00e9 ot\u00e1zky";
